import { render } from "./DeleteDialog.vue?vue&type=template&id=2c280abe&scoped=true"
import script from "./DeleteDialog.vue?vue&type=script&lang=js"
export * from "./DeleteDialog.vue?vue&type=script&lang=js"

import "./DeleteDialog.vue?vue&type=style&index=0&id=2c280abe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c280abe"]])

export default __exports__